import t from 'babel-plugin-yate/macro';
import React, {useCallback, useState} from 'react';
import {useDispatch} from 'react-redux';

import {sendEmailMobile, sendEmailNotification} from '../store/request';
import {sendEmailTransaction} from '../store/transaction';

import Text from '../components/uiElem/Text';
import Button from '../components/Button';

function SendEmail({id, type}) {
  const dispatch = useDispatch();
  const [isSend, setIsSend] = useState(false);
  const [error, setError] = useState(false);
  const configByType = {
    notify: {
      heading: t`Trimite email pe adresa utilizatorului`,
      success: t`Email-ul a fost trimis`,
      error: t`Deja a fost trimis email in ultimele 5 minute`,
      handler: sendEmailNotification,
    },
    mobile: {
      heading: t`Poti trimite aplicatia de credit pe adresa de email inregistrata daca doresti sa continui procesul folosind telefonul mobil`,
      success: t`Link-ul aplicatiei a fost trimis. Deschideti email-ul de pe telefonul mobil.`,
      error: t`Trimiterea email-ului a esuat :(`,
      handler: sendEmailMobile,
    },
    transaction: {
      heading: t`Trimite email pe adresa utilizatorului`,
      success: t`Email-ul a fost trimis`,
      error: t`Deja a fost trimis email in ultimele 5 minute`,
      handler: sendEmailTransaction,
    },
  };

  const byType = configByType[type];

  const sendEmail = useCallback(async () => {
    const {data} = await dispatch(byType.handler(id));

    if (data?.status === 'success' && !data?.messages[0]) {
      setIsSend(true);
    } else {
      setError(true);
    }
  }, [id, byType, dispatch]);

  return (
    <div
      className={`hidden lg:flex justify-center items-center ${error ? 'bg-red' : 'bg-orange'} rounded mt-5 px-32 py-2`}>
      {error ? (
        <div className="px-8">
          <Text ui="mercury">{byType.error}</Text>
        </div>
      ) : !isSend ? (
        <>
          <div className="px-8">
            <Text ui="mercury">{byType.heading}</Text>
          </div>
          <div className="px-8 flex-shrink-0">
            <Button
              title={t`Trimite email`}
              color="white"
              border={false}
              fullWidth
              customProps={{type: 'button'}}
              onClick={sendEmail}
            />
          </div>
        </>
      ) : (
        <div className="text-center">
          <Text ui="mercury">{byType.success}</Text>
        </div>
      )}
    </div>
  );
}

export default SendEmail;
